import { useParams } from "react-router-dom";
import { usePayPointQuery } from "Api/Queries/PayPoints/usePayPointQuery";
import { PaypointFormInitializer } from "Components/Paypoints/PaypointFormInitializer";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { useGoBack } from "Navigation/useGoBack";
import { useSearchParams } from "Navigation/useSearchParams";
import { isTerminalProductCode } from "Components/Shared/Merchant/Products/AppProducts/constants";

const RESOURCES = Resources.Paypoint;

export const PaypointDetailPage = () => {
  const { t } = useResource();
  const { publicID } = useParams<{ publicID: string }>();
  const { data: paypoint, isLoading, isError } = usePayPointQuery(publicID);
  const [searchParams] = useSearchParams();

  const { navigateBack } = useGoBack({
    mode: "historyStack",
    fallbackUrl: appUrl("paypoints"),
  });

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  if (isError || !paypoint) {
    return (
      <AuthenticatedLayout
        title={t(RESOURCES.NoPaypoint)}
        backNavigation={{
          mode: "historyStack",
          fallbackUrl: appUrl("paypoints"),
        }}
      >
        <StyledPageWrapper>
          <ErrorText>{t(RESOURCES.NoPaypoint)}</ErrorText>
        </StyledPageWrapper>
      </AuthenticatedLayout>
    );
  }

  const merchantPublicID = searchParams.get("merchantPublicID") || undefined;
  const isTerminalProduct = isTerminalProductCode(paypoint.productCode);

  return (
    <AuthenticatedLayout
      title={paypoint.name || t(RESOURCES.UnnamedPaypoint)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("paypoints"),
      }}
    >
      <StyledPageWrapper>
        <PrimaryPaper>
          <PaypointFormInitializer
            paypoint={paypoint}
            onSuccess={navigateBack}
            merchantPublicID={merchantPublicID}
            isTerminalProduct={isTerminalProduct}
          />
        </PrimaryPaper>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
